import { ApplicationConfig, provideBrowserGlobalErrorListeners, importProvidersFrom } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { provideKeycloak } from 'keycloak-angular';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { environment } from '../environments/environment';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { problemDetailsInterceptor } from '@core/interceptors/problem-details.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    //TODO: Setup ENV Variables to populate the keycloak values
    provideKeycloak({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
      }
    }),
    provideBrowserGlobalErrorListeners(),
    importProvidersFrom(MatNativeDateModule),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor, problemDetailsInterceptor])),
  ]
};
